// extracted by mini-css-extract-plugin
export default {"wrapper":"App_wrapper__WnIkY","authContent":"App_authContent__ol4ld"};